import BpkText, { TEXT_STYLES } from '@skyscanner-internal/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner-internal/backpack-web/bpk-react-utils';

import STYLES from './StatCard.module.scss';

const cls = cssModules(STYLES);

export type StatCardStatus = 'low' | 'expected' | 'high';

export type StatCardProps = {
  value: number;
  label: string;
  status: StatCardStatus;
};

const NUMBER_STATUS_CLASS: Record<StatCardStatus, string> = {
  low: 'numberLow',
  expected: 'numberExpected',
  high: 'numberHigh',
};

export const StatCard = ({ label, status, value }: StatCardProps) => (
  <div className={cls('card')}>
    <BpkText
      tagName="p"
      textStyle={TEXT_STYLES.hero6}
      className={cls('number', NUMBER_STATUS_CLASS[status])}
    >
      {value}
    </BpkText>
    <BpkText tagName="p" textStyle={TEXT_STYLES.bodyDefault} className={cls('label')}>
      {label}
    </BpkText>
  </div>
);
